import { Timer, now } from "./timer.js";
export default function (callback, delay, time) {
  var t = new Timer(),
      total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? now() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-timer@1.0.10@d3-timer/src/interval.js
// module id = 198
// module chunks = 0 1 2